import React from 'react';

function ArticleListFilters({
    searchTerm,
    onSearchTermChange,
    categoryFilter,
    onCategoryFilterChange,
    categories,
    sortBy,
    onSortByChange,
    sortFields,
    sortOrder,
    onSortOrderChange,
    onSubmit,
    onClear,
    canClear,
}) {
    return (
        <form onSubmit={onSubmit} className="process-queue-filters mb-4 p-3 bg-light rounded border">
            <div className="row g-2 g-md-3 align-items-center process-queue-filters__row">
                <div className="col-12 col-md-6 col-lg-auto process-queue-filters__item process-queue-filters__item--search">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Title</span>
                        <input
                            type="text"
                            className="form-control process-queue-filters__control"
                            placeholder="Search by title…"
                            value={searchTerm}
                            onChange={(e) => onSearchTermChange(e.target.value)}
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => onSearchTermChange('')}
                                aria-label="Clear search input"
                            >
                                <i className="bi bi-x"></i>
                            </button>
                        )}
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Category</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={categoryFilter}
                            onChange={(e) => onCategoryFilterChange(e.target.value)}
                        >
                            <option value="">All categories</option>
                            {categories.map((category) => (
                                <option key={category.id} value={category.id}>
                                    {category.title}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Sort by</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={sortBy}
                            onChange={(e) => onSortByChange(e.target.value)}
                        >
                            {sortFields.map((field) => (
                                <option key={field.value || 'createdAt'} value={field.value}>
                                    {field.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Order</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control process-queue-filters__control--narrow"
                            value={sortOrder}
                            onChange={(e) => onSortOrderChange(e.target.value)}
                            disabled={!sortBy}
                        >
                            <option value="asc">Asc</option>
                            <option value="desc">Desc</option>
                        </select>
                    </div>
                </div>

                <div className="col-12 col-lg-auto process-queue-filters__actions d-flex flex-nowrap gap-2">
                    <button type="submit" className="btn btn-primary btn-sm text-nowrap">
                        <i className="bi bi-search me-1"></i>
                        Search
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm text-nowrap"
                        onClick={onClear}
                        disabled={!canClear}
                        title="Clear filters"
                    >
                        <i className="bi bi-x-lg me-1"></i>
                        Clear
                    </button>
                </div>
            </div>
        </form>
    );
}

export default ArticleListFilters;
